import { Box, useMantineTheme } from '@mantine/core';

import { useGetColor } from 'hooks';

import type { IconPropsType } from './types';

export const WarningTwoToneIcon = ({
  color,
  size = 24,
  sx,
  ...props
}: IconPropsType) => {
  const mantineTheme = useMantineTheme();
  const iconColor = useGetColor(color);
  const backgroundColor = mantineTheme.fn.rgba(iconColor, 0.07);

  return (
    <Box
      component="svg"
      sx={sx}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width={24} height={24} rx={12} fill={backgroundColor} />
      <path
        d="M12 7v7.994m0 1.998V17"
        stroke={iconColor}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Box>
  );
};
